/**
 * @method capitalizeFirstLetter
 * @param {String} string
 * @return {String}
 */
export function capitalizeFirstLetter(string) {
  if (string) {
    return string.replace(/\b(\w)/g, (s) => s.toUpperCase());
  }
  return '';
}
export function insertSpaces(string) {
  string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
  string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
  return string;
}
